module.exports = __webpack_public_path__ + "static/equal-opportunities-227a9d782516ebd7616b2e0ddf2ca6ac.png";